import { render, staticRenderFns } from "./file-browser.vue?vue&type=template&id=ecbf107c&scoped=true&"
import script from "./file-browser.vue?vue&type=script&lang=js&"
export * from "./file-browser.vue?vue&type=script&lang=js&"
import style0 from "./file-browser.vue?vue&type=style&index=0&id=ecbf107c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbf107c",
  null
  
)

export default component.exports